'use strict';

var getColorMix = require('../../../../../../../../_virtual/getColorMix.cjs');
var extractAlpha = require('./extractAlpha.cjs');
var extractHex = require('./extractHex.cjs');

var hasRequiredGetColorMix;

function requireGetColorMix () {
	if (hasRequiredGetColorMix) return getColorMix.__exports;
	hasRequiredGetColorMix = 1;

	var extractAlpha$1 = extractAlpha.__require();
	var extractHex$1 = extractHex.__require();

	/**
	 * returns an oklab color-mix. Used for Opacity overlay effect
	 */ const getColorMix$1 = (defaultHex, effectAlphaHex)=>{
	    const effectHex = extractHex$1.extractHex(effectAlphaHex);
	    const effectAlpha = extractAlpha$1.extractAlpha(effectAlphaHex);
	    return `color-mix(in oklab, ${defaultHex} 100%, ${effectHex} ${effectAlpha}%)`;
	};

	getColorMix.__exports.getColorMix = getColorMix$1;
	
	return getColorMix.__exports;
}

exports.__require = requireGetColorMix;
//# sourceMappingURL=getColorMix.cjs.map
